import React from 'react';
import { Tooltip } from 'antd';
import { DeleteOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import styles from '../../Style/LayerOverview.module.scss'
import {IUploadedLayer} from "../../../../../types/legend";
import {ConvertRGBtoHex} from "../../../../../utils/common";

interface UploadedLayersProps {
  uploadedFeatures: IUploadedLayer[];
  visibleUploads: string[];
  onChangeUploadVisibility: (layerId: string) => void;
  deleteUpload: (layerId: string) => void;
  changeColor: (layer: IUploadedLayer) => void;
}

const UploadedLayers: React.FC<UploadedLayersProps> = ({
   uploadedFeatures,
   visibleUploads,
   onChangeUploadVisibility,
   deleteUpload,
   changeColor
 }) => {
  if (uploadedFeatures.length === 0) {
    return null;
  }

  return (
    <div className={styles.checkboxGroup}>
      {uploadedFeatures.map((layer) => {
        const color = ConvertRGBtoHex(layer.color);
        const isVisible = visibleUploads.includes(layer.id);

        return (
          <div key={layer.id} className={styles.menuRow}>
            <div className={styles.iconLabel}>
              <div
                style={{
                  cursor: 'pointer',
                  width: 20,
                  height: 20,
                  paddingLeft: 16,
                  border: `solid 3px ${color}`,
                }}
                onClick={() => changeColor(layer)}
              />
              <Tooltip title={layer.id}>
                <div className={styles.checkboxLabel}>
                  {layer.id}
                </div>
              </Tooltip>
            </div>
            <div className={`${styles.groupItem}`} style={{ alignItems: 'center' }}>
              <div style={{ cursor: 'pointer', fontSize: '15px', marginRight: 5 }}>
                <DeleteOutlined onClick={() => deleteUpload(layer.id)} />
              </div>
              <div style={{ cursor: 'pointer', fontSize: '20px' }}>
                {isVisible ? (
                  <EyeOutlined onClick={() => onChangeUploadVisibility(layer.id)} />
                ) : (
                  <EyeInvisibleOutlined onClick={() => onChangeUploadVisibility(layer.id)} />
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UploadedLayers;
